import { useState } from "react";

const useReplaceOptionValue = () => {
  const replaceOptionValue = (options, row, item) => {
    Object.entries(item.properties).map(([menu, value], index) => {
      setOptionDetailsValue(options, row, value)
    })
    Object.entries(item.styles).map(([menu, value], index) => {
      setOptionDetailsValue(options, row, value)
    })
  }

  const setOptionDetailsValue = (options, row, value) => {
    
    switch (value.option) {
      case undefined:
      case options.text: {  
        if(value.relationShipValue ) {
          const index = value.relationShipValue.findIndex(item => item == row.gridId)
         
          if (index != -1) {
            value.relationShipValue = getNewPath(row, value.relationShipValue, index) 
          }
        }
        break;
      }
      case options.condition: {
        
        value.conditions.values.values.forEach(item => {
          item.details.forEach(detail => {
            const firstOperandIndex = Array.isArray(detail.firstOperand.value) ? detail.firstOperand.value.findIndex(item => item == row.gridId) : -1
            const secondOperandIndex = Array.isArray(detail.secondOperand.value) ? detail.secondOperand.value.findIndex(item => item == row.gridId) : -1

            if (firstOperandIndex != -1) {
              detail.firstOperand.value = getNewPath(row, detail.firstOperand.value, firstOperandIndex) 
            }

            if (secondOperandIndex != -1) {
              detail.secondOperand.value = getNewPath(row, detail.secondOperand.value, secondOperandIndex) 
            }

          })
          
        });
        break;
      }
      
      case options.mapping: {
        
        break;
      }
  
      case options.tree: { 
       
        break;
      }
      
        
      case options.api: {
        
             
        break;
      }
      case options.list: {
        
             
        break;
      }
        
  
    }
   
  }


  const getNewPath = (row, paths, index) => {
   
    return [...paths.slice(0, index + 1), ...getColPath(row, paths.slice(index+1, paths.length)) ] 
  }

  const getColPath = (row, colPaths) => {
   
    var paths = [] 
    colPaths.map(col => {
      const index = row.settingsColIds.findIndex(settingsColId => settingsColId == col)
      if (index != -1)
        paths.push(row.newColIds[index])
      else paths.push(colPaths)
    })

    return paths
  }
  
  return replaceOptionValue;
};

export default useReplaceOptionValue;
